// extracted by mini-css-extract-plugin
export var buttonWrap = "PuzzleStep-module--buttonWrap--afe7f";
export var centerFlex = "PuzzleStep-module--centerFlex--f6fe6";
export var hide = "PuzzleStep-module--hide--f157c";
export var imageResult = "PuzzleStep-module--imageResult--86913";
export var introCopyWrap = "PuzzleStep-module--introCopyWrap--285d6";
export var puzzleContainer = "PuzzleStep-module--puzzleContainer--c24ee";
export var puzzleStep = "PuzzleStep-module--puzzleStep--88e9a";
export var puzzleStepContainer = "PuzzleStep-module--puzzleStepContainer--b7c11";
export var resultModal = "PuzzleStep-module--resultModal--10ae9 PuzzleStep-module--centerFlex--f6fe6";
export var show = "PuzzleStep-module--show--14447";
export var showGrid = "PuzzleStep-module--showGrid--a583c";
export var submit = "PuzzleStep-module--submit--a6948";
export var submitContainer = "PuzzleStep-module--submitContainer--92b86";